<template>
  <NouForm ref="editForm">
    <h2 class="g-title g-font-mid title">{{ $t('bounty.submit') }}</h2>
    <div class="tip">{{ $t('bounty.submitTip') }}</div>
    <NouFormItem class="g-form-item" :label="$t('bounty.description')">
      <TextArea v-model="content" />
    </NouFormItem>
    <PrimaryBtn class="g-form__confirm" :disabled="content.length===0" @click="handleClickSubmit">{{ $t('bounty.submit') }}</PrimaryBtn>
    <NouDialog :visible.sync="updateTipShowing" title="">
      <div class="resubmit">
        <h3 class="g-title resubmit-title g-font-mid">{{ $t('bounty.submitConfirm') }}</h3>
        <div class="resubmit-tip">{{ $t('bounty.resubmitTip') }}</div>
        <DefaultBtn class="btn" @click="$emit('close')">{{ $t('common.cancel') }}</DefaultBtn>
        <PrimaryBtn class="btn" @click="submit">{{ $t('common.confirm') }}</PrimaryBtn>
      </div>
    </NouDialog>
  </NouForm>
</template>

<script>
import TextArea from '@/components/TextArea.vue';
import PrimaryBtn from '@/components/PrimaryBtn.vue';
import URLS from '@/config/url';
import { BOUNTY_STATUS } from '@/config/enum';
import DefaultBtn from '@/components/DefaultBtn.vue';


export default {
  name: 'SubmitForm',
  components: {
    DefaultBtn, PrimaryBtn, TextArea,
  },
  props: {
    submitStatus: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      content: '',
      updateTipShowing: false,
    };
  },
  methods: {
    handleClickSubmit() {
      if (this.submitStatus !== BOUNTY_STATUS.unsubmitted) {
        this.updateTipShowing = true;
        return;
      }
      this.submit();
    },
    submit() {
      this.$request({
        url: URLS.submitSubmit,
        method: 'post',
        data: {
          ontid: this.$store.getters.id,
          bounty_id: Number(this.$route.query.id),
          content: this.content,
        },
      }).then(() => {
        this.$toast(this.$t('common.submitSuccess'));
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .title {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
  }

  .tip {
    margin-top: $padding-common;
    color: var(--color-content);
    line-height: 20px;
    text-align: center;
  }

  .resubmit {
    text-align: center;
  }

  .resubmit-title {
    font-size: 18px;
    line-height: 24px;
  }

  .resubmit-tip {
    margin-top: $padding-common;
    font-size: 14px;
    line-height: 20px;
    color: var(--color-content);
  }

  .btn {
    margin-top: $padding-common;
    width: 160px;
    height: 44px;

    & + & {
      margin-left: $padding-sm;
    }
  }
</style>
